module.exports = "/images/testimonial_background.png?3261b5566a75068b9e8668b9ce376dee";